export const UPDATE_CAB_FAQ_DATA  = "UPDATE_CAB_FAQ_DATA"
export const UPDATE_CABS_CONFIG_DATA = "UPDATE_CABS_CONFIG_DATA"